import { connect } from 'react-redux';
import { toggleReorderingAction } from 'redux/form/actions';
import { selectFormInitialResourceFromTable, selectIsReordering } from 'redux/form/selectors';
import { IRootState } from 'redux/reducer';
import { orc } from 'utils/strings/resourceClasses';

import { LayersFormSection as LayersFormSectionComponent } from './LayersFormSection.component';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;

const mapStateToProps = (rootState: IRootState) => {
  const construction = selectFormInitialResourceFromTable(orc.construction)(rootState);

  return {
    construction,
    isReordering: selectIsReordering(rootState),
  };
};

const mapDispatchToProps = {
  toggleReordering: toggleReorderingAction,
};

export type IInjectedProps = IStateProps & IDispatchProps;
export type IProps = IInjectedProps;

export const LayersFormSection = connect(mapStateToProps, mapDispatchToProps)(LayersFormSectionComponent);
